// 服务列表的接口
import request from '../../utils/request'

// 获取所有的市/获取机构类型

export function getjigouTypeList(data) {
  return request({
    url: '/sc/ticketMain/api/factJgjbxxb/listAll',
    method: 'get',
    params: data,
    headers: {
      isToken: false
    }
  })
}

// 获取所有的市/获取机构类型

export function getCityList(data) {
  return request({
    url: '/sc/ticketMain/api/factJgjbxxb/home/queryJgqyStatistics',
    method: 'get',
    params: data,
    headers: {
      isToken: false
    }
  })
}
// 获取机构 列表

export function getOrgList(data,isToken=false) {
  return request({
    url: '/sc/ticketMain/api/factJgjbxxb/home/page',
    method: 'get',
    params: data,
    headers: {
      isToken: isToken
    }
  })
}

// 获取服务详情

export function getServiesDetail(data,isToken = false) {
  return request({
    url: '/sc/ticketMain/api/factFwjbxxb/home/detail',
    method: 'get',
    params: data,
    headers: {
      isToken: isToken
    }
  })
}
// 获取机构详情
export function getOrgDetail(data, isToken = false) {
  return request({
    url: '/sc/ticketMain/api/factJgjbxxb/home/detail',
    method: 'get',
    params: data,
    headers: {
      isToken: isToken
    }
  })
}
// 机构下面的产品
export function getOrgPro(data, isToken = false) {
  return request({
    url: '/sc/ticketMain/api/factFwjbxxb/home/listByJgid',
    method: 'get',
    params: data,
    headers: {
      isToken: isToken
    }
  })
}

// 推荐服务列表

export function getRecommendServiesList(data) {
  return request({
    url: '/sc/ticketMain/api/factSc/home/recommendPage',
    method: 'get',
    params: data
  })
}

// 点击收藏

export function shoucangServies(data) {
  return request({
    url: '/sc/ticketMain/api/factSc/collect',
    method: 'post',
    headers: {
      isToken: true
    },
    data
  })
}

// 取消收藏
export function cancelShoucangServies(data) {
  return request({
    url: '/sc/ticketMain/api/factSc/delete',
    method: 'post',
    headers: {
      isToken: true
    },
    data
  })
}
// 收藏详情

export function shoucangDetail(data) {
  return request({
    url: '/sc/ticketMain/api/factSc/detail',
    method: 'get',
    params: data,
    headers: {
      isToken: true
    }
  })
}

// 投诉
export function tousu(data) {
  return request({
    url: '/sc/ticketMain/api/factTs/complaint',
    method: 'post',
    data
  })
}

// 查询评价
export function getQueryEvaluate(data) {
  return request({
    url: '/sc/ticketMain/api/factDfpjb/listByFwid',
    method: 'get',
    params: data
  })
}

// 下载文件
export function getdownloadFile(data) {
  return process.env.VUE_APP_BASE_API + 'sc/ticketMain/api/factFwjbxxb/previewFwzzFile?fileId=' + data
}
